import dayjs from "dayjs";

export const formatPhone = (phoneNumber) => {
  if (!phoneNumber) return null;
  const cleaned = phoneNumber.replace(/\D/g, "");
  if (cleaned.length < 4) return phoneNumber;
  const last4 = cleaned.slice(-4);
  return `****${last4}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return null;
  try {
    return dayjs(dateString).format("DD/MM/YYYY");
  } catch (e) {
    return null;
  }
};

export const getVerificationStatus = (
  ondatoStatus,
  translate,
  submission,
  isUserVerified,
) => {
  const t = translate || ((key) => key);

  if (isUserVerified) {
    return t("common.verified") || "Verified";
  }

  if (submission?.status === "pending") {
    return t("common.pending") || "Pending review";
  }

  if (Number(ondatoStatus) === 4) {
    return t("common.rejected") || "Rejected";
  }

  return t("common.unverified") || "Not verified";
};
